import { aplApi, IAplAmsLaSearchParams, IAplAmsLatamExportParams } from 'onboarding/api/aplApi'

class AplService {
  public exportAMSEligiblePartners(token: string) {
    return aplApi.exportAMSEligiblePartners(token)
  }

  public exportAmsLatamEligiblePartners(params: IAplAmsLatamExportParams, token: string) {
    return aplApi.exportAmsLatamEligiblePartners(params, token)
  }

  public checkAccessAmsSearch() {
    return aplApi.checkAccessAmsSearch()
  }

  public searchLA(payload: IAplAmsLaSearchParams) {
    return aplApi.searchLA(payload)
  }
}

export const aplService = new AplService()
